import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton, ScrollablePane, Stack } from '@fluentui/react';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { MarkdownViewer } from '../../components/MarkdownViewer';
import { ApiCalls } from '../../api/api';
import { SBOM_REPORT } from '../../constants/queryKeys';

const stripVersionSuffix = (version: string) => {
    let v = version;
    if (v.endsWith('.zip')) {
        v = v.replace('.zip', '');
    }
    const dashIndex = v.indexOf('-');
    if (dashIndex > 0) {
        v = v.slice(0, dashIndex);
    }
    return v;
};

export const SBOMViewer = ({ selectedVersion }: { selectedVersion?: string }) => {
    const { data = '', isLoading } = useQuery({
        queryKey: [SBOM_REPORT, selectedVersion],
        queryFn: async () => {
            const version = stripVersionSuffix(selectedVersion!);
            const res = await ApiCalls.request<string, unknown>({
                path: `/api/package-artifacts/sbom/${version}`,
                method: 'GET',
                secure: true,
                format: 'json',
            });
            return (res.data as string).replaceAll('===', '').replaceAll('\n', '\n\n');
        },
        enabled: Boolean(selectedVersion),
    });

    const [showDialog, setShowDialog] = useState(false);

    if (!selectedVersion) {
        return null;
    }

    return (
        <>
            <DefaultButton iconProps={{ iconName: 'ProductCatalog' }} disabled={!data || isLoading} onClick={() => setShowDialog(true)}>
                View SBOM
            </DefaultButton>
            <Dialog
                hidden={!showDialog}
                minWidth={600}
                maxWidth={600}
                onDismiss={() => setShowDialog(false)}
                dialogContentProps={{
                    type: DialogType.normal,
                }}
                modalProps={{
                    isClickableOutsideFocusTrap: true,
                    ignoreExternalFocusing: true,
                }}
            >
                <Stack styles={{ root: { height: '80vh' } }}>
                    <ScrollablePane>
                        <MarkdownViewer>{data}</MarkdownViewer>
                    </ScrollablePane>
                </Stack>
                <DialogFooter>
                    <PrimaryButton onClick={() => setShowDialog(false)} text="OK" />
                </DialogFooter>
            </Dialog>
        </>
    );
};
